module.exports = __webpack_public_path__ + "img/itomanman_comic03.7aac9433.jpg";